import { render, staticRenderFns } from "./ErrorCopiarInvitacionesModal.vue?vue&type=template&id=1f531cc1"
import script from "./ErrorCopiarInvitacionesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorCopiarInvitacionesModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports